import React, { FC } from "react";

import { useProvidersCurrentEmployee } from "~/hooks";

import { EmployeeLayout } from "~/components/layouts";
import { ProfilesShowTemplate } from "~/components/templates";

import { Loading } from "~/ui";

export const ManagersProfilesShow: FC = () => {
  const { currentEmployee } = useProvidersCurrentEmployee();

  const breadCrumbItems = [{ label: "マイページ", href: "/managers/profile" }];

  if (!currentEmployee) return <Loading className="mt-8" />;

  return (
    <EmployeeLayout withRightSidebar breadCrumbItems={breadCrumbItems}>
      <ProfilesShowTemplate currentEmployee={currentEmployee} />
    </EmployeeLayout>
  );
};
